import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ isAllowed }) => {
	if (!isAllowed) {
		return <Navigate to="/admin-login" replace />;
	}

	return <Outlet />;
};

export default ProtectedRoute;
